import baseUri from '../api/baseUri.ts';

const EXTERNAL_FRAME_TOKENS = [
    'allow-scripts',
    'allow-forms',
    'allow-popups',
    'allow-popups-to-escape-sandbox',
    'allow-modals',
    'allow-downloads',
    'allow-presentation',
    'allow-storage-access-by-user-activation'
];

/*
 * The sandbox for a web page a project author embeds (Embed sections, Website
 * tabs). Other sites keep their own origin, so their logins, players and
 * documents work as usual, but they can't navigate Mixiply away. A page on
 * Mixiply's own host, or any URL that isn't http(s) (a javascript: or data:
 * URL, say), gets an opaque origin instead, so it can't reach the app or the
 * viewer's session.
 */
export function externalFrameSandbox(url: string | null | undefined): string {
    let sameOriginAllowed = false;
    try {
        const parsed = new URL(url ?? '', window.location.href);
        sameOriginAllowed =
            (parsed.protocol === 'https:' || parsed.protocol === 'http:') &&
            parsed.origin !== window.location.origin &&
            parsed.origin !== new URL(baseUri).origin;
    } catch {
        sameOriginAllowed = false;
    }

    return (
        sameOriginAllowed
            ? ['allow-same-origin', ...EXTERNAL_FRAME_TOKENS]
            : EXTERNAL_FRAME_TOKENS
    ).join(' ');
}
